import { Context } from "../../Context";
import PropType from "prop-types";
import { useContext } from "react";

export const onClose = () => {
  if (document.body.classList.contains("is-basket-open")) {
    document.body.classList.remove("is-basket-open");
  } else {
    // document.body.classList.add("is-basket-open");
    // setMobileNavOpen(true);
  }
};

const BasketToggle = ({ children }) => {
  const { isMobileNavOpen, setMobileNavOpen } = useContext(Context);
  const onClickToggle = () => {
    if (document.body.classList.contains("is-basket-open")) {
      document.body.classList.remove("is-basket-open");
    } else {
      document.body.classList.add("is-basket-open");
      setMobileNavOpen(false);
    }
  };

  const onMenuToggle = () => {
    if (document.body.classList.contains("is-basket-open")) {
      document.body.classList.remove("is-basket-open");
    } else {
      document.body.classList.add("is-basket-open");
      setMobileNavOpen(true);
    }
  };

  document.addEventListener("click", (e) => {
    const closest = e.target.closest(".basket");
    const toggle = e.target.closest(".basket-toggle");
    const closeToggle = e.target.closest(".basket-item-remove");

    if (
      !closest &&
      document.body.classList.contains("is-basket-open") &&
      !toggle &&
      !closeToggle
    ) {
      document.body.classList.remove("is-basket-open");
    }
  });

  return children({ onClickToggle, onMenuToggle, onClose });
};

BasketToggle.propTypes = {
  children: PropType.oneOfType([
    PropType.arrayOf(PropType.node),
    PropType.func,
    PropType.node,
  ]).isRequired,
};

export default BasketToggle;
